<div class="relative" #dropdownContainer>
  <!-- Bell Button -->
  <button
    (click)="toggleDropdown()"
    class="relative p-2 hover:bg-white/10 rounded-lg transition flex items-center justify-center"
    [attr.aria-label]="'Notifications: ' + unreadCount + ' unread'"
  >
    <!-- use svg icon from assets for consistent styling and accessibility; button already has an aria-label -->
    <img
      src="assets/icons/bell-icon-filled-white.svg"
      alt=""
      aria-hidden="true"
      class="w-5.5 h-5.5"
    />

    <!-- Unread Count Badge -->
    @if (unreadCount > 0) {
      <span
        class="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white transform translate-x-1/2 -translate-y-1/2 bg-red-600 rounded-full min-w-6 h-6"
      >
        {{ unreadCount > 99 ? '99+' : unreadCount }}
      </span>
    }
  </button>

  <!-- Dropdown Menu -->
  @if (isDropdownOpen) {
    <div class="absolute right-0 mt-2 w-96 bg-white rounded-lg shadow-2xl z-40 overflow-hidden">
      <!-- Header -->
      <div
        class="bg-gradient-to-r from-secondary to-purple-800 text-white px-4 py-3 flex items-center justify-between"
      >
        <h3 class="font-semibold text-lg">Notifications</h3>
        @if (unreadCount > 0) {
          <button
            (click)="markAllAsRead()"
            class="text-sm text-white/80 hover:text-white transition"
          >
            Mark all as read
          </button>
        }
      </div>

      <!-- Notifications List -->
      <div class="max-h-108 overflow-y-auto">
        @if (displayNotifications.length === 0) {
          <div class="px-4 py-8 text-center text-gray-500">
            <p class="text-sm">No notifications</p>
          </div>
        } @else {
          @for (notification of displayNotifications; track notification.id) {
            <div
              (click)="navigateToNotification(notification)"
              [ngClass]="!notification.isRead ? 'bg-blue-50' : ''"
              class="px-4 py-3 border-b border-gray-100 hover:bg-gray-50 cursor-pointer transition relative"
            >
              <div class="flex items-start gap-3">
                <div class="text-2xl flex-shrink-0">
                  {{ getNotificationIcon(notification.type) }}
                </div>

                <div class="flex-1 min-w-0">
                  <h4 class="font-semibold text-sm text-gray-900">{{ notification.title }}</h4>
                  <p class="text-xs text-gray-600 mt-1 line-clamp-2">{{ notification.message }}</p>

                  @if (notification.relatedGroupName) {
                    <p class="text-xs text-gray-500 mt-1">📁 {{ notification.relatedGroupName }}</p>
                  }

                  <p class="text-xs text-gray-400 mt-2">{{ formatTime(notification.createdAt) }}</p>
                </div>

                <!-- Delete Button -->
                <button
                  (click)="deleteNotification(notification, $event)"
                  class="text-gray-400 hover:text-red-600 transition flex-shrink-0"
                  aria-label="Delete notification"
                >
                  ✕
                </button>
                <!-- Action Button -->
                @if (notification.actionUrl) {
                  <div class="absolute bottom-2 right-4">
                    <button
                      class="text-xs text-blue-600 font-semibold hover:text-blue-800 transition"
                    >
                      Take me there →
                    </button>
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>

      <!-- Footer: toggle + count -->
      <div
        class="flex items-center justify-between border-t border-gray-200 px-4 py-2 text-sm text-gray-500"
      >
        <button (click)="toggleShowRead()" class="hover:text-gray-700 transition">
          {{ showRead ? 'Show unread only' : 'Show all' }}
        </button>
        <span class="tabular-nums"
          >{{ displayNotifications.length }} notification{{
            displayNotifications.length !== 1 ? 's' : ''
          }}</span
        >
      </div>
    </div>
  }
</div>
